import React from "react";
import { useTranslation } from "react-i18next";
import ClubForm from "./ClubForm";

const ClubFormModal = ({ club, onSubmit, onCancel, loading }) => {
  const { t } = useTranslation("clubs");

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className={`fas ${club ? "fa-edit" : "fa-plus"} me-2`}></i>
              {club ? t("editClub") : t("addNewClub")}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onCancel}
              disabled={loading}
            ></button>
          </div>
          <div className="modal-body">
            <ClubForm club={club} onSubmit={onSubmit} onCancel={onCancel} loading={loading} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClubFormModal;
